import { useLemonadeContext, roundNumber } from "@/LemonadeProvider";

export function PurchaseHistory() {
    const { purchases } = useLemonadeContext();

    const sorted = [...purchases].sort((a, b) => b.date.getTime() - a.date.getTime());

    return (
        <section className="history-section purchase-history">
            <h2 className="main-title">Beszerzések</h2>
            <ul>
                {sorted.length === 0 && <li>Nincs beszerzés.</li>}
                {sorted.map((purchase) => (
                    <li key={purchase.date.getTime()}>
                        <b>{purchase.product}</b> – {roundNumber(purchase.amount.amount, 2)} {purchase.amount.unit} –{" "}
                        {roundNumber(purchase.price, 0)} Ft
                        <br />
                        <span style={{ color: "#bbb" }}>{purchase.date.toLocaleString("hu-HU")}</span>
                    </li>
                ))}
            </ul>
        </section>
    );
}
